import { render, staticRenderFns } from "./RegistrarBoleta.vue?vue&type=template&id=47c993cc&scoped=true"
import script from "./RegistrarBoleta.vue?vue&type=script&lang=js"
export * from "./RegistrarBoleta.vue?vue&type=script&lang=js"
import style0 from "./RegistrarBoleta.vue?vue&type=style&index=0&id=47c993cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c993cc",
  null
  
)

export default component.exports